"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubTeamListDataInSpace = exports.getEditMemberInfo = exports.getMemberListDataInSpace = exports.sendInviteEmail = exports.getTeamInfo = exports.selecteTeamRowsInModal = exports.selectedTeamKeysInModal = exports.updateInviteStatus = exports.updateTeamListInSpace = exports.updateSubTeamListInSpace = exports.updateSelectMemberListInSpace = exports.updateSelectedRowsInSpace = exports.updateMemberInfoInSpace = exports.updateRightClickTeamInfoInSpace = exports.updateSelectedTeamInfoInSpace = exports.updateMemberListInSpace = void 0;
const api_1 = require("../../../../exports/api");
const actions = __importStar(require("../../../shared/store/action_constants"));
const config_1 = require("../../../../config");
function updateMemberListInSpace(memberListInSpace) {
    return {
        type: actions.UPDATE_MEMBER_LIST_IN_SPACE,
        payload: memberListInSpace,
    };
}
exports.updateMemberListInSpace = updateMemberListInSpace;
function updateSelectedTeamInfoInSpace(info) {
    return {
        type: actions.UPDATE_SELECTED_TEAM_INFO_IN_SPACE,
        payload: info,
    };
}
exports.updateSelectedTeamInfoInSpace = updateSelectedTeamInfoInSpace;
function updateRightClickTeamInfoInSpace(info) {
    return {
        type: actions.UPDATE_RIGHT_CLICK_TEAM_INFO_IN_SPACE,
        payload: info,
    };
}
exports.updateRightClickTeamInfoInSpace = updateRightClickTeamInfoInSpace;
function updateMemberInfoInSpace(memberInfoInSpace) {
    return {
        type: actions.UPDATE_MEMBER_INFO_IN_SPACE,
        payload: memberInfoInSpace,
    };
}
exports.updateMemberInfoInSpace = updateMemberInfoInSpace;
function updateSelectedRowsInSpace(selectedRows) {
    return {
        type: actions.UPDATE_SELECTED_ROWS_IN_SPACE,
        payload: selectedRows,
    };
}
exports.updateSelectedRowsInSpace = updateSelectedRowsInSpace;
function updateSelectMemberListInSpace(selectMemberListInSpace) {
    return {
        type: actions.UPDATE_SELECT_MEMBER_LIST_IN_SPACE,
        payload: selectMemberListInSpace,
    };
}
exports.updateSelectMemberListInSpace = updateSelectMemberListInSpace;
function updateSubTeamListInSpace(subTeamListInSpace) {
    return {
        type: actions.UPDATE_SUB_TEAM_LIST_IN_SPACE,
        payload: subTeamListInSpace,
    };
}
exports.updateSubTeamListInSpace = updateSubTeamListInSpace;
function updateTeamListInSpace(teamListOfInvite) {
    return {
        type: actions.UPDATE_TEAM_LIST_IN_SPACE,
        payload: teamListOfInvite,
    };
}
exports.updateTeamListInSpace = updateTeamListInSpace;
function updateInviteStatus(isInvited) {
    return {
        type: actions.UPDATE_INVITED_STATUS,
        payload: isInvited,
    };
}
exports.updateInviteStatus = updateInviteStatus;
function selectedTeamKeysInModal(arr) {
    return {
        type: actions.UPDATE_SELECTED_TEAM_KEYS,
        payload: arr,
    };
}
exports.selectedTeamKeysInModal = selectedTeamKeysInModal;
function selecteTeamRowsInModal(arr) {
    return {
        type: actions.UPDATE_SELECTED_TEAM_ROWS,
        payload: arr,
    };
}
exports.selecteTeamRowsInModal = selecteTeamRowsInModal;
/**
 * Contacts - Team List
 * Get Team Info
 */
function getTeamInfo(_spaceId, teamId) {
    return (dispatch) => {
        api_1.Api.readTeam(teamId).then(res => {
            const { success, data } = res.data;
            success && dispatch(updateSelectedTeamInfoInSpace({
                teamTitle: data.teamName,
                memberCount: data.memberCount,
                teamId: data.teamId,
            }));
        }, err => {
            console.error('API.readTeam', err);
        });
    };
}
exports.getTeamInfo = getTeamInfo;
/**
 * Space - invite member by email
 * invite member by email
 */
function sendInviteEmail(_spaceId, invite) {
    return (dispatch) => {
        api_1.Api.sendInvite(invite).then(res => {
            const { success } = res.data;
            dispatch(updateInviteStatus(true));
            if (success) {
                api_1.Api.readTeam('0').then(res => {
                    const { success, data } = res.data;
                    success && dispatch(updateSelectedTeamInfoInSpace({
                        teamTitle: data.teamName,
                        memberCount: data.memberCount,
                        teamId: data.teamId,
                    }));
                }, err => {
                    console.error('API.readTeam', err);
                });
            }
        }, err => {
            console.error('API.sendInvite', err);
        });
    };
}
exports.sendInviteEmail = sendInviteEmail;
/**
 * Space-Contact-Members Management
 * Get members list by specific team with pagination
 */
function getMemberListDataInSpace(pageNo, teamId) {
    const pageObjectParams = {
        pageSize: config_1.ConfigConstant.MEMBER_LIST_PAGE_SIZE,
        order: 'createdAt',
        sort: config_1.ConfigConstant.SORT_ASC,
    };
    return (dispatch) => {
        api_1.Api.getMemberListInSpace(JSON.stringify(Object.assign(Object.assign({}, pageObjectParams), { pageNo })), teamId).then(res => {
            const { success, data } = res.data;
            if (success) {
                const memberListInSpace = data.records;
                dispatch(updateMemberListInSpace(memberListInSpace));
            }
        }, err => {
            console.error('API.getMemberListInSpace', err);
        });
    };
}
exports.getMemberListDataInSpace = getMemberListDataInSpace;
/**
 * Space-Contact-Members Management
 * Get Member detail
 */
function getEditMemberInfo(memberId) {
    return (dispatch) => {
        api_1.Api.getMemberInfo({ memberId }).then(res => {
            if (res.data.success) {
                dispatch(updateMemberInfoInSpace(res.data.data));
            }
        }, err => {
            console.error('API.getMemberInfo', err);
        });
    };
}
exports.getEditMemberInfo = getEditMemberInfo;
/**
 * Space-Team List
 * Get sub team list by specific team
 */
function getSubTeamListDataInSpace(teamId) {
    return (dispatch) => {
        api_1.Api.getSubTeams(teamId).then(res => {
            const { success, data } = res.data;
            if (success) {
                dispatch(updateSubTeamListInSpace(data));
            }
        }, err => {
            console.error('API.getSubTeams', err);
        });
    };
}
exports.getSubTeamListDataInSpace = getSubTeamListDataInSpace;
//# sourceMappingURL=space_member_manage.js.map